import { json } from "@sveltejs/kit";
const TARGET_DATE = (/* @__PURE__ */ new Date("2025-12-25T00:00:00")).getTime();
function GET() {
  const now = (/* @__PURE__ */ new Date()).getTime();
  const distance = TARGET_DATE - now;
  if (distance <= 0) {
    return json({
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
      expired: true
    });
  }
  const days = Math.floor(distance / (1e3 * 60 * 60 * 24));
  const hours = Math.floor(distance % (1e3 * 60 * 60 * 24) / (1e3 * 60 * 60));
  const minutes = Math.floor(distance % (1e3 * 60 * 60) / (1e3 * 60));
  const seconds = Math.floor(distance % (1e3 * 60) / 1e3);
  return json({
    days,
    hours,
    minutes,
    seconds,
    expired: false
  });
}
export {
  GET
};
